export class RoutePaths {
  static login = {
    path: 'login',
    onNavigate: () => '/login',
  };

  static loginCode = {
    path: 'logincode',
    onNavigate: () => '/logincode',
  };

  static register = {
    path: 'register',
    onNavigate: () => '/register',
  };

  static masterKey = {
    path: 'masterkey',
    onNavigate: () => '/masterkey',
  };

  static registerCode = {
    path: 'registercode',
    onNavigate: () => '/registercode',
  };

  static registerOk = {
    path: 'registerok',
    onNavigate: () => '/registerok',
  };

  static recovery = {
    path: 'recovery',
    onNavigate: () => '/recovery',
  };

  static forgot = {
    path: 'forgot',
    onNavigate: () => '/forgot',
  };

  static recoveryCode = {
    path: 'recoverycode',
    onNavigate: () => '/recoverycode',
  };

  static recoveryOk = {
    path: 'recoveryok',
    onNavigate: () => '/recoveryok',
  };

  static contact = {
    path: 'contact',
    onNavigate: () => '/contact',
  };

  static privacy = {
    path: 'privacy',
    onNavigate: () => '/privacy',
  };

  static cook = {
    path: 'cook',
    onNavigate: () => '/cook',
  };

  static conditions = {
    path: 'conditions',
    onNavigate: () => '/conditions',
  };

  static conditionsCard = {
    path: 'conditionscard',
    onNavigate: () => '/conditionscard',
  };

  static faq = {
    path: 'faq',
    onNavigate: () => '/faq',
  };

  static tariff = {
    path: 'tariff',
    onNavigate: () => '/tariff',
  };

  static home = {
    path: '',
    onNavigate: () => '/',
  };

  static cards = {
    path: 'cards',
    onNavigate: () => '/cards',
  };

  static profileSecurityAnswers = {
    path: 'profile/security-answers',
    onNavigate: () => '/profile/security-answers',
  };

  static profile = {
    path: 'profile',
    onNavigate: () => '/profile',
  };

  static products = {
    path: 'products',
    onNavigate: () => '/products',
  };

  static manageCards = {
    path: 'manage-cards',
    onNavigate: () => '/manage-cards',
  };

  static form = {
    path: 'form',
    onNavigate: () => '/form',
  };

  static disputedCharges = {
    path: 'disputed-charges',
    onNavigate: () => '/disputed-charges',
  };

  static letters = {
    path: 'letters',
    onNavigate: () => '/letters',
  };
}
